import React from 'react';
import PropTypes from 'prop-types';

function OrderSummaryItem({ title, amount, children }) {
    return (
        <div className="margin-b-16px text-align-left">
            <div className="flex justify-content-space-between">
                <span className="font-serif lg-font-size-20px font-size-16px font-blue-16">{ title }</span>
                <span className="font-serif lg-font-size-20px font-size-16px font-gray-40">${ amount }</span>
            </div>
            { children }
        </div>
    );
}

OrderSummaryItem.propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default OrderSummaryItem;
